export const openFileInNewWindow = (file: Blob, ) => {
  const blob = new Blob([file], { type: 'application/pdf' });
  const url = URL.createObjectURL(blob);
  window.open(url);
}
